export const subsetObject = <T>(object: T, propertiesToOmit: string[]): any => {
  const subsetObj: any = {};

  Object.keys(object as Record<string, any>).forEach((key: string) => {
    if (!propertiesToOmit.includes(key)) {
      subsetObj[key] = (object as Record<string, any>)[key];
    }
  });

  return subsetObj;
};
